import React, { useState, useCallback, useEffect, useContext } from "react";
import style from "./Tab3.module.scss";
import { v4 } from "uuid";
import TabList from '../../comm/global/components/TabList';
import { loadJson, wait } from "../../comm/comm";
import WeatherWidget from "../../comm/global/components/WeatherWidget";
import * as YStyled from "../../Styleds";
import CountryBar from "../../comm/global/components/CountryBar";
import { Collapse } from "@mui/material";
import styled from "styled-components";
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import apiManager from './../../ApiManager';
import AppConfig from '../../AppConfig';
import { GameContext } from "../../GameContext";
const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
}));
const Tab3 = ({ loginData, set_loginData, addModalType, set_menuVisiable, set_bottomSheetOpen }) => {
    const { userData } = useContext(GameContext);
    const [countryList, set_countryList] = useState([]);
    const [areaIndex, set_areaIndex] = useState(0);
    const [statistics, set_statistics] = useState(null);
    const [expanded, setExpanded] = useState(false);
    useEffect(() => {
        apiManager.fetchGet(`world/statistics`, {}, 0).then(res => {
            console.log("res", res)
            loadData(res.world_rewilding_country);
            set_statistics(res);
        })
    }, [])
    async function loadData(world_rewilding_country) {
        const countryList = await loadJson('./country.json');
        console.log("countryList", countryList);
        const changeCountryCount = (countryList, country) => {
            for (var k in countryList) {
                const countryListObj = countryList[k];
                const finded = countryListObj.country.find(v => v.countryCode === country.events_country_code);
                if (finded) {
                    finded.count = country.events_country_count;
                    break;
                }
            }
        }
        world_rewilding_country?.forEach(country => {
            console.log(country);
            changeCountryCount(countryList, country);
        });
        countryList.forEach(countryListObj => {
            countryListObj.country.sort((a, b) => {
                if (a.count === undefined) return 1;
                if (b.count === undefined) return -1;
                return b.count - a.count;
            });
        });

        set_countryList(countryList);
    }
    if (countryList.length > 0)
        return (
            <div className={style.app}>
                <YStyled.Row gap=".5rem">
                    <YStyled.Label style={{ height: "100%", width: "50%", alignItems: "flex-start" }} onClick={e => {
                        /* addModalType({cls:"Charity"}); */
                    }}>
                        <YStyled.Col gap="0.5rem" style={{opacity:"0.5"}}>
                            <YStyled.Span size={17}>公益</YStyled.Span>
                            <YStyled.Span size={12}>敬請期待</YStyled.Span>
                        </YStyled.Col>
                    </YStyled.Label>
                    <YStyled.Label style={{ height: "100%", width: "50%" }} onClick={e => {
                        if (userData)
                            addModalType({ cls: "AddFriend" });
                        else
                        window.location.href = AppConfig.registerUrl();
                    }}>
                        <YStyled.Col gap="1.5rem">
                            <YStyled.Span size={17}>新增好友</YStyled.Span>
                            <img src="./assets/ui/Avatars.png" />
                        </YStyled.Col>
                        <img src="./assets/ui/add_yellow.svg" style={{ position: "absolute", top: "15px", right: "15px" }} />
                    </YStyled.Label>
                </YStyled.Row>
                <YStyled.Label style={{ width: "100%" ,opacity:"0.5"}} onClick={e => {
                    //addModalType({ cls: "Rank" });
                }}>
                    <YStyled.Col gap="0.5rem">
                        <YStyled.Span size={17}>排行榜</YStyled.Span>
                        <YStyled.Span size={12}>本季 Top 5</YStyled.Span>
                    </YStyled.Col>
                </YStyled.Label>
                <YStyled.Label style={{ width: "100%" ,opacity:"0.5"}}>
                    <YStyled.Col gap="0.5rem">
                        <YStyled.Span size={17}>小舖</YStyled.Span>
                        <YStyled.Span size={12}>敬請期待</YStyled.Span>
                    </YStyled.Col>
                </YStyled.Label>
                {/* <YStyled.Label style={{ width: "100%", height: "auto" }}>
                    <YStyled.Col>
                        <YStyled.Span style={{ alignSelf: "center" }}>OOSA News</YStyled.Span>
                        <YStyled.Row style={{ height: "4rem" }} gap=".5rem">
                            <YStyled.Col>
                                <YStyled.Span>{`${statistics?.world_rewilding_polaroid}`}</YStyled.Span>
                                <YStyled.Span>野放點到訪數</YStyled.Span>
                            </YStyled.Col>
                            <YStyled.Vr style={{ height: "70%" }} />
                            <YStyled.Col>
                                <YStyled.Span>{`${statistics?.world_rewilding_members}`}</YStyled.Span>
                                <YStyled.Span>總野放人次</YStyled.Span>
                            </YStyled.Col>
                        </YStyled.Row>
                        <YStyled.Row>
                            {countryList.map((v, k) => {
                                return <YStyled.Span style={{ cursor: "pointer" }} key={k}
                                    className={`${style.areaItem} ${k === areaIndex ? style.selected : ""}`}
                                    onClick={e => {
                                        set_areaIndex(k);
                                    }} size={15} fontWeight={400}>{v.area}</YStyled.Span>
                            })}
                        </YStyled.Row>
                        {countryList[areaIndex].country.filter(v => v.count > 0).slice(0, 5).map((v, k) => {
                            return <CountryBar key={k} name={v.name} count={v.count} max={1000} />
                        })}
                        <Collapse in={expanded} timeout="auto" style={{ width: "100%" }}>
                            {countryList[areaIndex].country.filter(v => v.count > 0).slice(5).map((v, k) => {
                                return <CountryBar key={k} name={v.name} count={v.count} max={1000} />
                            })}
                        </Collapse>
                        <YStyled.Row align="center">
                            <YStyled.Span size={13}>{expanded ? "收合" : "展開"}</YStyled.Span>
                            <ExpandMore
                                expand={expanded}
                                onClick={e => { setExpanded(!expanded); }}
                                aria-expanded={expanded}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </YStyled.Row>

                        <YStyled.Row align="center">
                            <YStyled.Span size={12} color="#aaa">達千次野放或</YStyled.Span>
                            <YStyled.Span size={12} color="#00f" style={{ textDecoration: "underline" }}>贊助</YStyled.Span>
                            <YStyled.Span size={12} color="#aaa">，將開啟該國星空地圖</YStyled.Span>
                        </YStyled.Row>
                    </YStyled.Col>
                </YStyled.Label>
                <YStyled.Label style={{ width: "100%", height: "auto" }}>
                    <YStyled.Col gap=".5rem">
                        <YStyled.Span style={{ alignSelf: "center" }} size={17}>吸氣。吐氣。放輕鬆</YStyled.Span>
                        <YStyled.Span style={{ alignSelf: "center" }} color="#aaa" size={12}>深呼吸，紓解壓力</YStyled.Span>
                        <iframe width="100%" style={{ borderRadius: "6px" }} src="https://www.youtube.com/embed/Z7ftRiib_s4" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullscreen></iframe>
                    </YStyled.Col>
                </YStyled.Label> */}
                <YStyled.Label style={{ width: "100%", height: "auto" }}>
                    <YStyled.Col gap=".5rem">
                        <YStyled.Span style={{ alignSelf: "center" }} size={17}>跟好友一起探索世界</YStyled.Span>
                        <YStyled.Span style={{ alignSelf: "center" }} color="#aaa" size={12}>你想知道的都在這裡</YStyled.Span>
                        <YStyled.Row>
                            <YStyled.Col align="center" onClick={e => {
                                window.open("https://www.instagram.com/oosa.life?igsh=OGQ5ZDc2ODk2ZA%3D%3D&utm_source=qr", "_blank");
                            }}>
                                <img src="./assets/ui/insta.png" />
                                <YStyled.Span size={11}>Instagram</YStyled.Span>
                                <YStyled.Span size={11}>OOSA</YStyled.Span>
                            </YStyled.Col>
                            <YStyled.Col align="center" onClick={e => {
                                window.open("https://www.facebook.com/profile.php?id=61567770029645", "_blank");
                            }}>
                                <img src="./assets/ui/fb.png" />
                                <YStyled.Span size={11}>Facebook</YStyled.Span>
                                <YStyled.Span size={11}>OOSA</YStyled.Span>
                            </YStyled.Col>
                            <YStyled.Col align="center" onClick={e => {
                                window.open("https://liff.line.me/1645278921-kWRPP32q/?accountId=oosa", "_blank");
                            }}>
                                <img src="./assets/ui/line.png" />
                                <YStyled.Span size={11}>Line</YStyled.Span>
                                <YStyled.Span size={11}>OOSA</YStyled.Span>
                            </YStyled.Col>
                        </YStyled.Row>
                    </YStyled.Col>
                </YStyled.Label>
            </div>
        );
}

export default Tab3;